import React from 'react';
import { classNames, layoutClassNames } from './classNames';
import type { LayoutClassNameProps } from './classNames';

export interface CloseButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'>, LayoutClassNameProps {
  label?: string;
  white?: boolean;
}

const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(({
  label = 'Fermer',
  white = false,
  type = 'button',
  className,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={classNames(
      'btn-close',
      white ? 'btn-close-white' : undefined,
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    aria-label={label}
    {...props}
  />
));

CloseButton.displayName = 'CloseButton';

export default CloseButton;
